export default __webpack_public_path__ + "static/media/kyc-level-rejected.e7186930.svg";